export const helpPages = [
  {
    path: '/help/memberPayHelp',
    name: 'memberPayHelp',
    component: () => import('views/help/memberPayHelp'),
    meta: {
      title: '帮助'
    }
  },
  {
    path: '/help/notImmediatelyHelp',
    name: 'notImmediatelyHelp',
    component: () => import('views/help/notImmediatelyHelp'),
    meta: {
      title: '常见问题'
    }
  },
  {
    path: '/help/autoVoiceHelp/:brand',
    name: 'autoVoiceHelp',
    component: () => import('views/help/autoVoiceHelp'),
    meta: {
      title: '手机设置'
    }
  },
  {
    path: '/help/bluetoothHelp',
    name: 'bluetoothHelp',
    component: () => import('views/help/bluetoothHelp/index'),
    meta: {
      title: '打印机设置帮助'
    }
  },
  {
    path: '/help/answer',
    name: 'bluetoothHelpAnswer',
    component: () => import('views/help/bluetoothHelp/answer'),
    meta: {
      title: '安装步骤'
    }
  },
  {
    path: '/help/messageRemind',
    name: 'messageRemind',
    component: () => import('views/help/messageRemind'),
    meta: {
      title: '消息提醒'
    }
  },
  {
    path: '/help/messageRemind/iosPushSetting',
    name: 'iosPushSetting',
    component: () => import('views/help/messageRemind/iosPushSetting'),
    meta: {
      title: 'ios设置说明'
    }
  },
  {
    path: '/help/messageRemind/huaweiHonorPushHelp',
    name: 'huaweiHonorPushHelp',
    component: () => import('views/help/messageRemind/huaweiHonorPushHelp'),
    meta: {
      title: '华为荣耀8.0设置说明'
    }
  },
  {
    path: '/help/messageRemind/onePlusPushHelp',
    name: 'onePlusPushHelp',
    component: () => import('views/help/messageRemind/onePlusPushHelp'),
    meta: {
      title: '一加手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/oppoPushHelp',
    name: 'oppoPushHelp',
    component: () => import('views/help/messageRemind/oppoPushHelp'),
    meta: {
      title: 'OPPP手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/vivoPushHelp',
    name: 'vivoPushHelp',
    component: () => import('views/help/messageRemind/vivoPushHelp'),
    meta: {
      title: 'ViVO手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/vivoPushHelp',
    name: 'vivoPushHelp',
    component: () => import('views/help/messageRemind/vivoPushHelp'),
    meta: {
      title: 'ViVO手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/xiaomiPushHelp',
    name: 'xiaomiPushHelp',
    component: () => import('views/help/messageRemind/xiaomiPushHelp'),
    meta: {
      title: '小米手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/samsungPushHelp',
    name: 'samsungPushHelp',
    component: () => import('views/help/messageRemind/samsungPushHelp'),
    meta: {
      title: '三星手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/mateNinePushDirection',
    name: 'mateNinePushDirection',
    component: () => import('views/help/messageRemind/mateNinePushDirection'),
    meta: {
      title: '华为Mate9手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/honorPushDirection',
    name: 'honorPushDirection',
    component: () => import('views/help/messageRemind/honorPushDirection'),
    meta: {
      title: '华为荣耀6Plus、荣耀7、荣耀8手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/huaweiWheatPushDirection',
    name: 'huaweiWheatPushDirection',
    component: () => import('views/help/messageRemind/huaweiWheatPushDirection'),
    meta: {
      title: '华为麦芒手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/oppoUnderSevenPushDirection',
    name: 'oppoUnderSevenPushDirection',
    component: () => import('views/help/messageRemind/oppoUnderSevenPushDirection'),
    meta: {
      title: 'OPPO7.0及以下手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/vivoXsevenPushDirection',
    name: 'vivoXsevenPushDirection',
    component: () => import('views/help/messageRemind/vivoXsevenPushDirection'),
    meta: {
      title: 'VivoX7手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/xiaomiUnderEightPushDirection',
    name: 'xiaomiUnderEightPushDirection',
    component: () => import('views/help/messageRemind/xiaomiUnderEightPushDirection'),
    meta: {
      title: '小米8.0以下手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/redmiPushDirection',
    name: 'redmiPushDirection',
    component: () => import('views/help/messageRemind/redmiPushDirection'),
    meta: {
      title: '红米Note手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/sansungVersionSixPushDirection',
    name: 'sansungVersionSixPushDirection',
    component: () => import('views/help/messageRemind/sansungVersionSixPushDirection'),
    meta: {
      title: '三星6.0及以上系统手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/sansungVersionFivePushDirection',
    name: 'sansungVersionFivePushDirection',
    component: () => import('views/help/messageRemind/sansungVersionFivePushDirection'),
    meta: {
      title: '三星5.0系统手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/sansungVersionFourPushDirection',
    name: 'sansungVersionFourPushDirection',
    component: () => import('views/help/messageRemind/sansungVersionFourPushDirection'),
    meta: {
      title: '三星4.0系统手机设置说明'
    }
  },
  {
    path: '/help/messageRemind/smartisanPushDirection',
    name: 'smartisanPushDirection',
    component: () => import('views/help/messageRemind/smartisanPushDirection'),
    meta: {
      title: '锤子手机设置说明'
    }
  }
]
